export const configs = {
    gtmId: process.env.REACT_APP_GTMID,
    greetingGeneratorApi: process.env.REACT_APP_GREETING_GENERATOR_SERVICE,
}
